export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  image: string;
}

export const categories: Category[] = [
  {
    slug: '热血格斗',
    name: '热血格斗',
    description: '拳拳到肉的激烈对决，燃烧灵魂的热血战斗，让你每一页都充满力量！',
    icon: 'ri-fire-line',
    count: 3,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20with%20explosive%20energy%2C%20warrior%20silhouette%20against%20warm%20orange%20sunset%2C%20ink%20splash%20effects%2C%20Japanese%20manga%20battle%20aesthetic%2C%20vibrant%20warm%20colors%2C%20stylized%20illustration&width=800&height=500&seq=cat-img-01&orientation=landscape',
  },
  {
    slug: '恋爱校园',
    name: '恋爱校园',
    description: '樱花树下的青春悸动，教室里的甜蜜时光，最美的初恋故事都在这里。',
    icon: 'ri-heart-line',
    count: 2,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20school%20scene%20with%20cherry%20blossoms%2C%20soft%20sunlight%20through%20classroom%20windows%2C%20gentle%20pink%20and%20warm%20golden%20tones%2C%20Japanese%20romance%20anime%20aesthetic%2C%20dreamy%20illustration&width=800&height=500&seq=cat-img-02&orientation=landscape',
  },
  {
    slug: '玄幻奇幻',
    name: '玄幻奇幻',
    description: '穿越九天十地，掌控天地法则，在宏大的修仙世界中书写属于你的传说。',
    icon: 'ri-magic-line',
    count: 3,
    image: 'https://readdy.ai/api/search-image?query=Mystical%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20golden%20celestial%20palace%2C%20clouds%20and%20dragons%2C%20warm%20divine%20light%2C%20Chinese%20xianxia%20art%20style%2C%20ethereal%20atmosphere&width=800&height=500&seq=cat-img-03&orientation=landscape',
  },
  {
    slug: '悬疑推理',
    name: '悬疑推理',
    description: '抽丝剥茧破解迷案，层层反转挑战思维极限，真相永远超乎你的想象。',
    icon: 'ri-search-eye-line',
    count: 3,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20scene%20with%20magnifying%20glass%20and%20evidence%2C%20dramatic%20shadow%20and%20warm%20light%20contrast%2C%20film%20noir%20atmosphere%2C%20Japanese%20mystery%20manga%20aesthetic%2C%20intriguing%20composition&width=800&height=500&seq=cat-img-04&orientation=landscape',
  },
  {
    slug: '搞笑日常',
    name: '搞笑日常',
    description: '笑到停不下来的欢乐日常，轻松治愈的校园生活，让每一天都充满笑声。',
    icon: 'ri-emotion-laugh-line',
    count: 2,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20playful%20anime%20comedy%20scene%2C%20chibi%20characters%20having%20fun%2C%20bright%20sunny%20classroom%2C%20Japanese%20comedy%20manga%20style%2C%20warm%20cheerful%20colors%2C%20lively%20illustration&width=800&height=500&seq=cat-img-05&orientation=landscape',
  },
  {
    slug: '科幻未来',
    name: '科幻未来',
    description: '探索星际的无限可能，机甲与AI的世界，未来已来，你准备好了吗？',
    icon: 'ri-rocket-line',
    count: 2,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20city%20with%20flying%20vehicles%20and%20holograms%2C%20stars%20and%20nebula%20in%20sky%2C%20warm%20neon%20accents%2C%20Japanese%20sci%20fi%20anime%20background%2C%20awe-inspiring%20scale&width=800&height=500&seq=cat-img-06&orientation=landscape',
  },
];